export default __webpack_public_path__ + "static/media/phinestsWebsite.ed9690eb.png";